import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import params from '../config/params'

Vue.use(Vuex);

const state = {
	config:params,
	sys_name:'校360学习管家',
	ui_config:{

	},
	show_tabbar:true,
	show_topbar:true,
	login_logo:'images/login_logo.jpg',
	copyright:'版权所有&copy;2017 ygwo.net',
	openid:'',
	isLoading:false,
	direction:'forward',
	show_footer:true,
	user:{
		openid:'',
		login_time:0,
		login_server_time:0,
		expire_time:0,
		token:'',
		info:null,
		notice: {
			today_attendance_num:0,
			today_broadcast_num:0,
			today_course_num:0,
			today_review_num:0
		}
	},
	jssdk:{
		ready:false,
		request_time:0,
		expire:7200,
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    	appId: '', // 必填，公众号的唯一标识
    	timestamp:0 , // 必填，生成签名的时间戳
    	nonceStr: '', // 必填，生成签名的随机串
    	signature: '',// 必填，签名，见附录1
    	jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
	},
	session:{
	},
	gvars:{

	},
	maps: {
		
	},
	ws_host:'',
	base_url:'',
	socket: {
      isConnected: false,
      isUserOnline:false,
      uid:0,
      fd:0,
      message: '',
      event:'',
      data:{},
      user_error:'',
      error:false
    },

    chat_upload:{
    	popup:false,
    	started:false,
    	path:'',
    	status:0,
    	msg:'',
    	data:{
    		file_type:'',
    		file_url:'',
    		file_size:''
    	}
    },
    hw_tab: 0
}

const getters = {
	isLogin(state){
		let cur_time = (new Date()).getTime() / 1000
		let expired_time = state.user.login_time + state.user.expire_time
		return state.user.login_time > 0 && expired_time > cur_time
	},
	isLock(){
		let islock = Vue.localStorage.get('islock')
		return String(islock) === 'true'
	},
	getGlobalVar:(state,getter)=>(name)=>{
		return state.gvars[name]
	},
	jssdkReady(state){
		return state.jssdk.ready
	}
}


export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js